/**
 * expo-device, derived from the user agent. Only the fields the app reports in
 * feedback and error tracking are provided; anything the browser cannot know is
 * null, which is what the callers already handle ("unknown" fallbacks).
 */
const ua = typeof navigator === "undefined" ? "" : navigator.userAgent;

const match = (re: RegExp) => ua.match(re)?.[1] ?? null;

export const isDevice = true;

export const brand: string | null = null;

export const modelName: string | null = (() => {
  if (/iPhone/.test(ua)) return "iPhone";
  if (/iPad/.test(ua)) return "iPad";
  if (/Android/.test(ua)) return match(/Android[^;]*;\s*([^)]+?)(?:\sBuild|\))/);
  if (/Macintosh/.test(ua)) return "Mac";
  if (/Windows/.test(ua)) return "Windows PC";
  return null;
})();

export const osName: string | null = (() => {
  if (/Windows/.test(ua)) return "Windows";
  if (/Android/.test(ua)) return "Android";
  if (/iPhone|iPad|iPod/.test(ua)) return "iOS";
  if (/Mac OS X/.test(ua)) return "macOS";
  if (/Linux/.test(ua)) return "Linux";
  return null;
})();

export const osVersion: string | null =
  match(/Windows NT ([\d._]+)/) ??
  match(/Android ([\d._]+)/) ??
  match(/OS ([\d_]+) like Mac OS X/)?.replace(/_/g, ".") ??
  match(/Mac OS X ([\d_]+)/)?.replace(/_/g, ".") ??
  null;

/** expo's DeviceType enum; the app only compares against these. */
export const DeviceType = {
  UNKNOWN: 0,
  PHONE: 1,
  TABLET: 2,
  DESKTOP: 3,
  TV: 4,
} as const;

export const deviceType: number = /iPad|Tablet/.test(ua)
  ? DeviceType.TABLET
  : /Mobi|iPhone|Android/.test(ua)
    ? DeviceType.PHONE
    : DeviceType.DESKTOP;
